// extracted by mini-css-extract-plugin
export default {"contenedor":"Modal_contenedor__PED73","infoCartel":"Modal_infoCartel__Pj4r1","cartelOculto":"Modal_cartelOculto__glZBQ"};